if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      const buttons = Array.from(this.querySelectorAll('.collection-tabs__list-link'));
      const targetId = this.dataset.target;
      const container = document.getElementById(targetId);
      if (!container) return;

      const carousels = Array.from(container.querySelectorAll('.carousel'));

carousels.forEach(carousel => {
  if (!carousel.classList.contains('flickity-enabled')) {
    const flkty = new Flickity(carousel, {
      cellSelector: '.carousel__slide',
      wrapAround: true,              // loop infinito
      autoPlay: false,                // autoplay 4s
      pauseAutoPlayOnHover: true,    // pausa su hover
      pageDots: false,
      prevNextButtons: true,         // lasciato true (puoi mettere false se usi solo custom)
      contain: true
    });

    // Collega i pulsanti custom se presenti
    const prevButton = carousel.querySelector('.flickity-prev');
    const nextButton = carousel.querySelector('.flickity-next');

    if (prevButton && nextButton) {
      prevButton.addEventListener('click', () => flkty.previous());
      nextButton.addEventListener('click', () => flkty.next());
    }

    // Progress bar (opzionale)
    const progressBar = carousel.parentElement.querySelector('.flickity-progress--bar');
    if (progressBar) {
      flkty.on('scroll', (progress) => {
        progress = Math.max(0, Math.min(1, progress));
        progressBar.style.width = `${progress * 100}%`;
      });
    }
  }
});

      

      buttons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const collection = button.dataset.collection;

          // Attiva/disattiva pulsanti
          buttons.forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');

          // Mostra solo il carousel della collection selezionata
          carousels.forEach(carousel => {
            const isMatch = carousel.dataset.collection === collection;
            carousel.style.display = isMatch ? 'block' : 'none';

            if (isMatch) {
              const flickityInstance = Flickity.data(carousel);
              if (flickityInstance) {
                flickityInstance.resize();
                flickityInstance.select(0);
              }
            }
          });
        });
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
